/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 13. ジェンガ */
export const template13 = {
  title: t.to('ジェンガ', 'title13'),
  desc: t.to(
    `提供された3列 x 7段で組み立てられたVRジェンガからブロックを引き抜いて、上に積み上げていきましょう。
  プログラムの情報からイメージして、最も高くブロックを積み上げられる戦略を考えてください。
  まずは3分プログラムを読み解いてください。「一番上のY軸はいくつでしょう？」「どこを変えたらブロックを上に移動できるでしょう？」。その後５分でプレイします。ぜひ2名ペアになって協力しながら進めてください。
  `,
    'desc13'
  ),
  img: '../public/template/13.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="225" y="56">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="a-camera_v2.1">
        <field name="position-x">0</field>
        <field name="position-y">5</field>
        <field name="position-z">4</field>
        <field name="click_type">mouse</field>
        <next>
          <block type="cube_v2">
            <field name="id">土台</field>
            <field name="position-x">0</field>
            <field name="position-y">1</field>
            <field name="position-z">-1</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#2f9585</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">8</field>
                <field name="scale-y">0.2</field>
                <field name="scale-z">10</field>
                <value name="ATTR">
                  <block type="a-static-body_v2">
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">block7</field>
                <field name="position-x">-1</field>
                <field name="position-y">7.6</field>
                <field name="position-z">-1</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#ff0000</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="scale_v2">
                    <field name="scale-x">1</field>
                    <field name="scale-y">1</field>
                    <field name="scale-z">4</field>
                    <value name="ATTR">
                      <block type="a-dynamic-body_v2">
                        <field name="mass">5</field>
                        <value name="ATTR">
                          <block type="push_v2">
                            <field name="power">5</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="cube_v2">
                    <field name="id">block7</field>
                    <field name="position-x">0</field>
                    <field name="position-y">7.6</field>
                    <field name="position-z">-1</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#26ff00</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">1</field>
                        <field name="scale-y">1</field>
                        <field name="scale-z">4</field>
                        <value name="ATTR">
                          <block type="a-dynamic-body_v2">
                            <field name="mass">5</field>
                            <value name="ATTR">
                              <block type="push_v2">
                                <field name="power">5</field>
                              </block>
                            </value>
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="cube_v2">
                        <field name="id">block7</field>
                        <field name="position-x">1</field>
                        <field name="position-y">7.6</field>
                        <field name="position-z">-1</field>
                        <value name="COLOUR">
                          <shadow type="color_value_v2">
                            <field name="COLOUR">#3b00ff</field>
                          </shadow>
                        </value>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">1</field>
                            <field name="scale-y">1</field>
                            <field name="scale-z">4</field>
                            <value name="ATTR">
                              <block type="a-dynamic-body_v2">
                                <field name="mass">5</field>
                                <value name="ATTR">
                                  <block type="push_v2">
                                    <field name="power">5</field>
                                  </block>
                                </value>
                              </block>
                            </value>
                          </block>
                        </value>
                        <next>
                          <block type="cube_v2">
                            <field name="id">block6</field>
                            <field name="position-x">0</field>
                            <field name="position-y">6.6</field>
                            <field name="position-z">-2</field>
                            <value name="COLOUR">
                              <shadow type="color_value_v2">
                                <field name="COLOUR">#ff0000</field>
                              </shadow>
                            </value>
                            <value name="ATTR">
                              <block type="scale_v2">
                                <field name="scale-x">4</field>
                                <field name="scale-y">1</field>
                                <field name="scale-z">1</field>
                                <value name="ATTR">
                                  <block type="a-dynamic-body_v2">
                                    <field name="mass">5</field>
                                    <value name="ATTR">
                                      <block type="push_v2">
                                        <field name="power">5</field>
                                      </block>
                                    </value>
                                  </block>
                                </value>
                              </block>
                            </value>
                            <next>
                              <block type="cube_v2">
                                <field name="id">block6</field>
                                <field name="position-x">0</field>
                                <field name="position-y">6.6</field>
                                <field name="position-z">-1</field>
                                <value name="COLOUR">
                                  <shadow type="color_value_v2">
                                    <field name="COLOUR">#2eff00</field>
                                  </shadow>
                                </value>
                                <value name="ATTR">
                                  <block type="scale_v2">
                                    <field name="scale-x">4</field>
                                    <field name="scale-y">1</field>
                                    <field name="scale-z">1</field>
                                    <value name="ATTR">
                                      <block type="a-dynamic-body_v2">
                                        <field name="mass">5</field>
                                        <value name="ATTR">
                                          <block type="push_v2">
                                            <field name="power">5</field>
                                          </block>
                                        </value>
                                      </block>
                                    </value>
                                  </block>
                                </value>
                                <next>
                                  <block type="cube_v2">
                                    <field name="id">block6</field>
                                    <field name="position-x">0</field>
                                    <field name="position-y">6.6</field>
                                    <field name="position-z">0</field>
                                    <value name="COLOUR">
                                      <shadow type="color_value_v2">
                                        <field name="COLOUR">#4300ff</field>
                                      </shadow>
                                    </value>
                                    <value name="ATTR">
                                      <block type="scale_v2">
                                        <field name="scale-x">4</field>
                                        <field name="scale-y">1</field>
                                        <field name="scale-z">1</field>
                                        <value name="ATTR">
                                          <block type="a-dynamic-body_v2">
                                            <field name="mass">5</field>
                                            <value name="ATTR">
                                              <block type="push_v2">
                                                <field name="power">5</field>
                                              </block>
                                            </value>
                                          </block>
                                        </value>
                                      </block>
                                    </value>
                                    <next>
                                      <block type="cube_v2">
                                        <field name="id">block5</field>
                                        <field name="position-x">-1</field>
                                        <field name="position-y">5.6</field>
                                        <field name="position-z">-1</field>
                                        <value name="COLOUR">
                                          <shadow type="color_value_v2">
                                            <field name="COLOUR">#ff0000</field>
                                          </shadow>
                                        </value>
                                        <value name="ATTR">
                                          <block type="scale_v2">
                                            <field name="scale-x">1</field>
                                            <field name="scale-y">1</field>
                                            <field name="scale-z">4</field>
                                            <value name="ATTR">
                                              <block type="a-dynamic-body_v2">
                                                <field name="mass">5</field>
                                                <value name="ATTR">
                                                  <block type="push_v2">
                                                    <field name="power">5</field>
                                                  </block>
                                                </value>
                                              </block>
                                            </value>
                                          </block>
                                        </value>
                                        <next>
                                          <block type="cube_v2">
                                            <field name="id">block5</field>
                                            <field name="position-x">0</field>
                                            <field name="position-y">5.6</field>
                                            <field name="position-z">-1</field>
                                            <value name="COLOUR">
                                              <shadow type="color_value_v2">
                                                <field name="COLOUR">#32ff00</field>
                                              </shadow>
                                            </value>
                                            <value name="ATTR">
                                              <block type="scale_v2">
                                                <field name="scale-x">1</field>
                                                <field name="scale-y">1</field>
                                                <field name="scale-z">4</field>
                                                <value name="ATTR">
                                                  <block type="a-dynamic-body_v2">
                                                    <field name="mass">5</field>
                                                    <value name="ATTR">
                                                      <block type="push_v2">
                                                        <field name="power">5</field>
                                                      </block>
                                                    </value>
                                                  </block>
                                                </value>
                                              </block>
                                            </value>
                                            <next>
                                              <block type="cube_v2">
                                                <field name="id">block5</field>
                                                <field name="position-x">1</field>
                                                <field name="position-y">5.6</field>
                                                <field name="position-z">-1</field>
                                                <value name="COLOUR">
                                                  <shadow type="color_value_v2">
                                                    <field name="COLOUR">#3700ff</field>
                                                  </shadow>
                                                </value>
                                                <value name="ATTR">
                                                  <block type="scale_v2">
                                                    <field name="scale-x">1</field>
                                                    <field name="scale-y">1</field>
                                                    <field name="scale-z">4</field>
                                                    <value name="ATTR">
                                                      <block type="a-dynamic-body_v2">
                                                        <field name="mass">5</field>
                                                        <value name="ATTR">
                                                          <block type="push_v2">
                                                            <field name="power">5</field>
                                                          </block>
                                                        </value>
                                                      </block>
                                                    </value>
                                                  </block>
                                                </value>
                                                <next>
                                                  <block type="cube_v2">
                                                    <field name="id">block4</field>
                                                    <field name="position-x">0</field>
                                                    <field name="position-y">4.6</field>
                                                    <field name="position-z">-2</field>
                                                    <value name="COLOUR">
                                                      <shadow type="color_value_v2">
                                                        <field name="COLOUR">#ff0000</field>
                                                      </shadow>
                                                    </value>
                                                    <value name="ATTR">
                                                      <block type="scale_v2">
                                                        <field name="scale-x">4</field>
                                                        <field name="scale-y">1</field>
                                                        <field name="scale-z">1</field>
                                                        <value name="ATTR">
                                                          <block type="a-dynamic-body_v2">
                                                            <field name="mass">5</field>
                                                            <value name="ATTR">
                                                              <block type="push_v2">
                                                                <field name="power">5</field>
                                                              </block>
                                                            </value>
                                                          </block>
                                                        </value>
                                                      </block>
                                                    </value>
                                                    <next>
                                                      <block type="cube_v2">
                                                        <field name="id">block4</field>
                                                        <field name="position-x">0</field>
                                                        <field name="position-y">4.6</field>
                                                        <field name="position-z">-1</field>
                                                        <value name="COLOUR">
                                                          <shadow type="color_value_v2">
                                                            <field name="COLOUR">#32ff00</field>
                                                          </shadow>
                                                        </value>
                                                        <value name="ATTR">
                                                          <block type="scale_v2">
                                                            <field name="scale-x">4</field>
                                                            <field name="scale-y">1</field>
                                                            <field name="scale-z">1</field>
                                                            <value name="ATTR">
                                                              <block type="a-dynamic-body_v2">
                                                                <field name="mass">5</field>
                                                                <value name="ATTR">
                                                                  <block type="push_v2">
                                                                    <field name="power">5</field>
                                                                  </block>
                                                                </value>
                                                              </block>
                                                            </value>
                                                          </block>
                                                        </value>
                                                        <next>
                                                          <block type="cube_v2">
                                                            <field name="id">block4</field>
                                                            <field name="position-x">0</field>
                                                            <field name="position-y">4.6</field>
                                                            <field name="position-z">0</field>
                                                            <value name="COLOUR">
                                                              <shadow type="color_value_v2">
                                                                <field name="COLOUR">#4300ff</field>
                                                              </shadow>
                                                            </value>
                                                            <value name="ATTR">
                                                              <block type="scale_v2">
                                                                <field name="scale-x">4</field>
                                                                <field name="scale-y">1</field>
                                                                <field name="scale-z">1</field>
                                                                <value name="ATTR">
                                                                  <block type="a-dynamic-body_v2">
                                                                    <field name="mass">5</field>
                                                                    <value name="ATTR">
                                                                      <block type="push_v2">
                                                                        <field name="power">5</field>
                                                                      </block>
                                                                    </value>
                                                                  </block>
                                                                </value>
                                                              </block>
                                                            </value>
                                                            <next>
                                                              <block type="cube_v2">
                                                                <field name="id">block3</field>
                                                                <field name="position-x">-1</field>
                                                                <field name="position-y">3.6</field>
                                                                <field name="position-z">-1</field>
                                                                <value name="COLOUR">
                                                                  <shadow type="color_value_v2">
                                                                    <field name="COLOUR">#ff0000</field>
                                                                  </shadow>
                                                                </value>
                                                                <value name="ATTR">
                                                                  <block type="scale_v2">
                                                                    <field name="scale-x">1</field>
                                                                    <field name="scale-y">1</field>
                                                                    <field name="scale-z">4</field>
                                                                    <value name="ATTR">
                                                                      <block type="a-dynamic-body_v2">
                                                                        <field name="mass">5</field>
                                                                        <value name="ATTR">
                                                                          <block type="push_v2">
                                                                            <field name="power">5</field>
                                                                          </block>
                                                                        </value>
                                                                      </block>
                                                                    </value>
                                                                  </block>
                                                                </value>
                                                                <next>
                                                                  <block type="cube_v2">
                                                                    <field name="id">block3</field>
                                                                    <field name="position-x">0</field>
                                                                    <field name="position-y">3.6</field>
                                                                    <field name="position-z">-1</field>
                                                                    <value name="COLOUR">
                                                                      <shadow type="color_value_v2">
                                                                        <field name="COLOUR">#26ff00</field>
                                                                      </shadow>
                                                                    </value>
                                                                    <value name="ATTR">
                                                                      <block type="scale_v2">
                                                                        <field name="scale-x">1</field>
                                                                        <field name="scale-y">1</field>
                                                                        <field name="scale-z">4</field>
                                                                        <value name="ATTR">
                                                                          <block type="a-dynamic-body_v2">
                                                                            <field name="mass">5</field>
                                                                            <value name="ATTR">
                                                                              <block type="push_v2">
                                                                                <field name="power">5</field>
                                                                              </block>
                                                                            </value>
                                                                          </block>
                                                                        </value>
                                                                      </block>
                                                                    </value>
                                                                    <next>
                                                                      <block type="cube_v2">
                                                                        <field name="id">block3</field>
                                                                        <field name="position-x">1</field>
                                                                        <field name="position-y">3.6</field>
                                                                        <field name="position-z">-1</field>
                                                                        <value name="COLOUR">
                                                                          <shadow type="color_value_v2">
                                                                            <field name="COLOUR">#3b00ff</field>
                                                                          </shadow>
                                                                        </value>
                                                                        <value name="ATTR">
                                                                          <block type="scale_v2">
                                                                            <field name="scale-x">1</field>
                                                                            <field name="scale-y">1</field>
                                                                            <field name="scale-z">4</field>
                                                                            <value name="ATTR">
                                                                              <block type="a-dynamic-body_v2">
                                                                                <field name="mass">5</field>
                                                                                <value name="ATTR">
                                                                                  <block type="push_v2">
                                                                                    <field name="power">5</field>
                                                                                  </block>
                                                                                </value>
                                                                              </block>
                                                                            </value>
                                                                          </block>
                                                                        </value>
                                                                        <next>
                                                                          <block type="cube_v2">
                                                                            <field name="id">block2</field>
                                                                            <field name="position-x">0</field>
                                                                            <field name="position-y">2.6</field>
                                                                            <field name="position-z">-2</field>
                                                                            <value name="COLOUR">
                                                                              <shadow type="color_value_v2">
                                                                                <field name="COLOUR">#ff0000</field>
                                                                              </shadow>
                                                                            </value>
                                                                            <value name="ATTR">
                                                                              <block type="scale_v2">
                                                                                <field name="scale-x">4</field>
                                                                                <field name="scale-y">1</field>
                                                                                <field name="scale-z">1</field>
                                                                                <value name="ATTR">
                                                                                  <block type="a-dynamic-body_v2">
                                                                                    <field name="mass">5</field>
                                                                                    <value name="ATTR">
                                                                                      <block type="push_v2">
                                                                                        <field name="power">5</field>
                                                                                      </block>
                                                                                    </value>
                                                                                  </block>
                                                                                </value>
                                                                              </block>
                                                                            </value>
                                                                            <next>
                                                                              <block type="cube_v2">
                                                                                <field name="id">block2</field>
                                                                                <field name="position-x">0</field>
                                                                                <field name="position-y">2.6</field>
                                                                                <field name="position-z">-1</field>
                                                                                <value name="COLOUR">
                                                                                  <shadow type="color_value_v2">
                                                                                    <field name="COLOUR">#21ff00</field>
                                                                                  </shadow>
                                                                                </value>
                                                                                <value name="ATTR">
                                                                                  <block type="scale_v2">
                                                                                    <field name="scale-x">4</field>
                                                                                    <field name="scale-y">1</field>
                                                                                    <field name="scale-z">1</field>
                                                                                    <value name="ATTR">
                                                                                      <block type="a-dynamic-body_v2">
                                                                                        <field name="mass">5</field>
                                                                                        <value name="ATTR">
                                                                                          <block type="push_v2">
                                                                                            <field name="power">5</field>
                                                                                          </block>
                                                                                        </value>
                                                                                      </block>
                                                                                    </value>
                                                                                  </block>
                                                                                </value>
                                                                                <next>
                                                                                  <block type="cube_v2">
                                                                                    <field name="id">block2</field>
                                                                                    <field name="position-x">0</field>
                                                                                    <field name="position-y">2.6</field>
                                                                                    <field name="position-z">0</field>
                                                                                    <value name="COLOUR">
                                                                                      <shadow type="color_value_v2">
                                                                                        <field name="COLOUR">#3f00ff</field>
                                                                                      </shadow>
                                                                                    </value>
                                                                                    <value name="ATTR">
                                                                                      <block type="scale_v2">
                                                                                        <field name="scale-x">4</field>
                                                                                        <field name="scale-y">1</field>
                                                                                        <field name="scale-z">1</field>
                                                                                        <value name="ATTR">
                                                                                          <block type="a-dynamic-body_v2">
                                                                                            <field name="mass">5</field>
                                                                                            <value name="ATTR">
                                                                                              <block type="push_v2">
                                                                                                <field name="power">5</field>
                                                                                              </block>
                                                                                            </value>
                                                                                          </block>
                                                                                        </value>
                                                                                      </block>
                                                                                    </value>
                                                                                    <next>
                                                                                      <block type="cube_v2">
                                                                                        <field name="id">block1</field>
                                                                                        <field name="position-x">-1</field>
                                                                                        <field name="position-y">1.6</field>
                                                                                        <field name="position-z">-1</field>
                                                                                        <value name="COLOUR">
                                                                                          <shadow type="color_value_v2">
                                                                                            <field name="COLOUR">#ff0000</field>
                                                                                          </shadow>
                                                                                        </value>
                                                                                        <value name="ATTR">
                                                                                          <block type="scale_v2">
                                                                                            <field name="scale-x">1</field>
                                                                                            <field name="scale-y">1</field>
                                                                                            <field name="scale-z">4</field>
                                                                                            <value name="ATTR">
                                                                                              <block type="a-dynamic-body_v2">
                                                                                                <field name="mass">5</field>
                                                                                                <value name="ATTR">
                                                                                                  <block type="push_v2">
                                                                                                    <field name="power">5</field>
                                                                                                  </block>
                                                                                                </value>
                                                                                              </block>
                                                                                            </value>
                                                                                          </block>
                                                                                        </value>
                                                                                        <next>
                                                                                          <block type="cube_v2">
                                                                                            <field name="id">block1</field>
                                                                                            <field name="position-x">0</field>
                                                                                            <field name="position-y">1.6</field>
                                                                                            <field name="position-z">-1</field>
                                                                                            <value name="COLOUR">
                                                                                              <shadow type="color_value_v2">
                                                                                                <field name="COLOUR">#21ff00</field>
                                                                                              </shadow>
                                                                                            </value>
                                                                                            <value name="ATTR">
                                                                                              <block type="scale_v2">
                                                                                                <field name="scale-x">1</field>
                                                                                                <field name="scale-y">1</field>
                                                                                                <field name="scale-z">4</field>
                                                                                                <value name="ATTR">
                                                                                                  <block type="a-dynamic-body_v2">
                                                                                                    <field name="mass">5</field>
                                                                                                    <value name="ATTR">
                                                                                                      <block type="push_v2">
                                                                                                        <field name="power">5</field>
                                                                                                      </block>
                                                                                                    </value>
                                                                                                  </block>
                                                                                                </value>
                                                                                              </block>
                                                                                            </value>
                                                                                            <next>
                                                                                              <block type="cube_v2">
                                                                                                <field name="id">block1</field>
                                                                                                <field name="position-x">1</field>
                                                                                                <field name="position-y">1.6</field>
                                                                                                <field name="position-z">-1</field>
                                                                                                <value name="COLOUR">
                                                                                                  <shadow type="color_value_v2">
                                                                                                    <field name="COLOUR">#3700ff</field>
                                                                                                  </shadow>
                                                                                                </value>
                                                                                                <value name="ATTR">
                                                                                                  <block type="scale_v2">
                                                                                                    <field name="scale-x">1</field>
                                                                                                    <field name="scale-y">1</field>
                                                                                                    <field name="scale-z">4</field>
                                                                                                    <value name="ATTR">
                                                                                                      <block type="a-dynamic-body_v2">
                                                                                                        <field name="mass">5</field>
                                                                                                        <value name="ATTR">
                                                                                                          <block type="push_v2">
                                                                                                            <field name="power">5</field>
                                                                                                          </block>
                                                                                                        </value>
                                                                                                      </block>
                                                                                                    </value>
                                                                                                  </block>
                                                                                                </value>
                                                                                                <next>
                                                                                                  <block type="environment_v2">
                                                                                                    <field name="environment">preset:forest</field>
                                                                                                  </block>
                                                                                                </next>
                                                                                              </block>
                                                                                            </next>
                                                                                          </block>
                                                                                        </next>
                                                                                      </block>
                                                                                    </next>
                                                                                  </block>
                                                                                </next>
                                                                              </block>
                                                                            </next>
                                                                          </block>
                                                                        </next>
                                                                      </block>
                                                                    </next>
                                                                  </block>
                                                                </next>
                                                              </block>
                                                            </next>
                                                          </block>
                                                        </next>
                                                      </block>
                                                    </next>
                                                  </block>
                                                </next>
                                              </block>
                                            </next>
                                          </block>
                                        </next>
                                      </block>
                                    </next>
                                  </block>
                                </next>
                              </block>
                            </next>
                          </block>
                        </next>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

`,
};
